exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wx-dialog .el-dialog__header{\r\n  border-bottom: none;\r\n  line-height: 30px;\r\n  padding-top: 32px;\r\n  padding-bottom: 12px;\r\n  height: auto;\n}\n.wx-dialog .el-dialog__body{\r\n  padding-bottom: 100px;\n}\r\n", ""]);

// exports
